import { render, staticRenderFns } from "./MyTasksPage.vue?vue&type=template&id=74ecc154"
import script from "./MyTasksPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyTasksPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ecc154')) {
      api.createRecord('74ecc154', component.options)
    } else {
      api.reload('74ecc154', component.options)
    }
    module.hot.accept("./MyTasksPage.vue?vue&type=template&id=74ecc154", function () {
      api.rerender('74ecc154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Pages/TaskManagement/Components/MyTasksPage.vue"
export default component.exports